import { useMedicalChronology } from "@/components/MedicalChronology/contexts/MedicalChronologyContext";
import React from "react";

import { useCaseImages } from "../../../hooks/useCaseImages";
import { ImagesView } from "./ImagesView";

export const Images: React.FC = () => {
  const { caseId, openCitation } = useMedicalChronology();
  const { images, isLoading, error, handleImageLoadError } = useCaseImages(caseId);

  return (
    <ImagesView
      images={images}
      loading={isLoading}
      error={error}
      onCitationClick={openCitation}
      onImageLoadError={handleImageLoadError}
    />
  );
};
